import { useRouteMatch } from "react-router-dom";

export const useGetFriendlyUrl = () => {
  const match = useRouteMatch<{
    friendlyUrl: string;
  }>({
    path: "/e-rezerwacja/:friendlyUrl",
  });

  return { friendlyUrl: match?.params?.friendlyUrl || "default" };
};
